var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { logBadgeHistoryActionFunctionDef } from '../../../../backend/features/badges/shared';
import { NoAccountForBulkActionDialogContent } from '../../../../ui/features/badge-management/components/NoAccountForBulkActionDialogContent';
import { useGetAccountsToNotify } from '../../../../ui/features/badge-management/hooks/useGetAccountsToNotify';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { showNotificationDialog } from '@juvare/alert-ui/ui/features/alerts';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
export function useAccountBadgeNotifyBulkAction({ badgeId, accountBadgeSelectedIds, appliedStorageFilters, }) {
    const { t } = useBadgingTranslation();
    const logBadgeHistoryAction = useTypedPlatformFunction(logBadgeHistoryActionFunctionDef);
    const { getAccountsToNotify } = useGetAccountsToNotify({
        accountBadgeSelectedIds,
        appliedStorageFilters,
        badgeId,
    });
    const handleNotify = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const accountsToNotify = yield getAccountsToNotify();
        if (accountsToNotify.accountToNotifyIds.length === 0) {
            return showCustomDialog({
                maxWidth: 'sm',
                content: (close) => (React.createElement(NoAccountForBulkActionDialogContent, { bulkActionTitle: t('badges.badgeDetails.accountBadgeTable.notification.bulkActionTitle'), onClose: close })),
                onEscapeKeyDown: (close) => close(),
            });
        }
        showNotificationDialog({
            onSubmitSuccess: (_, onClose) => {
                showAlertSnackbar({
                    message: t('badges.badgeDetails.accountBadgeTable.notification.sentTo', {
                        count: accountsToNotify.accountToNotifyIds.length,
                    }),
                    type: 'success',
                    autoHideDuration: 2000,
                });
                onClose();
                logBadgeHistoryAction({
                    accountBadgeIds: accountsToNotify.accountBadgeToNotifyIds,
                    badgeId: badgeId,
                    action: 'accountBadgeNotificationSent',
                }).catch(handleErrorSnackbar);
            },
            mode: 'notification',
            reviewFormHeader: t('badges.badgeDetails.accountBadgeTable.notification.reviewAndSend'),
            wizardHeader: t('badges.badgeDetails.accountBadgeTable.notification.createNotification'),
            partialAlert: {
                recipients: {
                    internal: {
                        includeNonMembers: false,
                        accounts: accountsToNotify.accountToNotifyIds,
                        groups: [],
                        organizations: [],
                    },
                },
            },
        });
    }), [badgeId, getAccountsToNotify, logBadgeHistoryAction, t]);
    return { handleNotify };
}
